import { createWebHistory, createRouter } from "vue-router";

import HomePage from "@/views/HomePage";
import HireMe from "@/views/HireMe";
import BlogProjects from "@/views/BlogProjects";
import BlogProjectsSingle from "@/views/BlogProjectsSingle";
const LostAndFound = () => import("@/views/LostAndFound");

import routes from "./routes.js";

routes.find((r) => r.component === "HomePage").component = HomePage;
routes.find((r) => r.component === "HireMe").component = HireMe;
routes.find((r) => r.component === "BlogProjects").component = BlogProjects;
routes.find((r) => r.component === "BlogProjectsSingle").component =
  BlogProjectsSingle;
routes.find((r) => r.component === "LostAndFound").component = LostAndFound;

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
